import { useState } from 'react'

const EMOJI_GROUPS: Record<string, string[]> = {
  Smileys: ['😀','😁','😂','🤣','😃','😄','😅','😆','😇','😉','😊','🙂','🙃','😋','😎','🥳','😍','🤩','😘','😗','😙','😚','😜','🤪','😝','🤗','🤔','🤭','🤫','🤥','😑','😶','😏','😒','🙄','😬','🤨','😕','😟','🙁','😮','😯','😲','😳','🥺','😦','😧','😨','😰','😥','😢','😭','😱','😖','😣','😞','😓','😩','😫','🥱','😤','😡','😠','🤬'],
  Gestures: ['👋','🤚','🖐','✋','🖖','👌','🤌','🤏','✌','🤞','🤟','🤘','🤙','👈','👉','👆','🖕','👇','☝','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏'],
  Hearts: ['❤','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣','💕','💞','💓','💗','💖','💘','💝','💟'],
  Animals: ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐔','🐧','🐦','🦆','🦅','🦉','🦇','🐝','🐛','🦋','🐌','🐞','🐜','🐢','🐍','🦎'],
  Food: ['🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🥑','🍆','🥦','🥬','🥒','🌶','🧄','🧅','🥔','🍠','🌽','🥕','🧇','🥞','🧈','🍳','🥓','🥩','🍗','🍖','🌭','🍔','🍟','🍕','🥪','🥙','🧆','🌮','🌯'],
  Travel: ['🚗','🚕','🚙','🚌','🚎','🏎','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🛵','🏍','🚲','🛴','🚏','🛣','⛽','🚦','🚥','🗺','🧭','⛵','🚤','🛥','🛳','⛴','🚢','✈','🛩','🚁','🛸','🛶','🚀'],
  Objects: ['⌚','📱','💻','⌨','🖥','🖨','🖱','💽','💾','💿','📀','📷','📸','📹','🎥','📺','📻','🧭','⏱','⏲','⏰','🕰','⌛','⏳','📡','🔋','🔌','💡','🔦','🕯','💰','💵','💴','💶','💷','💸','💳','🪙'],
}

interface Props {
  onSelect: (emoji: string) => void
  onClose: () => void
  inline?: boolean
}

export function EmojiPicker({ onSelect, onClose, inline }: Props) {
  const [tab, setTab] = useState('Smileys')
  const groups = Object.keys(EMOJI_GROUPS)

  return (
    <div className={`w-72 bg-bg-primary border border-divider overflow-hidden z-50 animate-fade-in
      ${inline ? 'rounded-b-2xl border-t-0' : 'absolute bottom-full mb-2 left-0 rounded-2xl shadow-2xl'}`}>
      {/* Tabs */}
      <div className="flex border-b border-divider overflow-x-auto scrollbar-hide">
        {groups.map((group) => (
          <button
            key={group}
            onClick={() => setTab(group)}
            className={`px-3 py-2 text-sm shrink-0 transition-colors ${
              tab === group
                ? 'text-accent border-b-2 border-accent'
                : 'text-txt-meta hover:text-txt-primary'
            }`}
          >
            {EMOJI_GROUPS[group][0]}
          </button>
        ))}
      </div>

      {/* Emoji grid */}
      <div className="grid grid-cols-8 gap-0.5 p-2 max-h-48 overflow-y-auto">
        {EMOJI_GROUPS[tab].map((emoji) => (
          <button
            key={emoji}
            onClick={() => { onSelect(emoji); onClose() }}
            className="text-xl p-1.5 rounded-lg hover:bg-bg-hover transition-colors text-center leading-none"
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  )
}
